import React, {useEffect, useState} from "react";
import {Title} from "../../../components/components";
import {useHistory, useParams} from "react-router-dom";
import Icon from "../../../components/Icon";
import {Button} from "react-bootstrap";
import {CmpPreview} from "../../../components/cmp/CmpPreview";
import CmpConfiguration from "../../../components/cmp/CmpConfiguration";

import {useGetAppQuery} from "../../../api/appApiSlice";
import usePublisherCmpConfiguration from "../../api_hooks/usePublisherCmpConfiguration";

export default function CmpAppConfiguration(props) {
  const {appId} = useParams();
  const history = useHistory();

  const params = {configurableType: 'app', configurableId: appId}

  const {cmpPreviewProps, cmpConfigurationProps} = usePublisherCmpConfiguration(params)
  const {data: app = {}, isAppSuccess} = useGetAppQuery({appId})

  return (
    <>
      <Title main={app.name || app.bundle_id} sub="CMP Configuration" onBack={()=>(history.push(`/cmp/configuration`))}>
        <Button onClick={() => cmpPreviewProps.setAppPreviewId(app.id)}>
          <Icon icon='mobile' text={"Preview"} />
        </Button>
      </Title>
      <CmpConfiguration {...cmpConfigurationProps} />
      <CmpPreview {...cmpPreviewProps} />
    </>
  )
}

